<template>
  <div
    v-if="student"
    v-b-tooltip.hover
    class="student-link d-flex align-items-center justify-content-between"
    :to="`/essays?filters[studentId]=${student.id}`"
    :title="fullName"
  >
    <div v-if="student.avatar" class="student-avatar d-flex flex-shrink-0 mr-1">
      <img :src="student.avatar" alt="Student avatar" />
    </div>
    <slot name="prefix" /> {{ fullName }} <slot name="suffix" />
  </div>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      required: true,
    },
  },

  computed: {
    fullName() {
      return `${this.student.firstName} ${this.student.lastName}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.student-avatar {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--light);

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
</style>
